import apiClient from '@/clients/apiClient';

export const getFinancialOverview = (StartAt = '', EndAt = '') =>
  apiClient.get(`overview/finances?StartAt=${StartAt}&EndAt=${EndAt}`);

export const getLoanPerformanceOverview = () =>
  apiClient.get(`overview/loans/performance`);

export const getRiskAssetDistribution = () =>
  apiClient.get(`overview/loans/distribution`);

export const getLoanValuesByGroup = (grouping = '') =>
  apiClient.get(`overview/loans/values?grouping=${grouping}`);

export const getPastLoanCountByGroup = (grouping = '') =>
  apiClient.get(`overview/loans/past-due?grouping=${grouping}`);

export const getActionQueueData = () => apiClient.get(`action-queues`);

export const getGlobalDashboardMetrics = (StartAt = '', EndAt = '') =>
  apiClient.get(`overview/global-dashboard?StartAt=${StartAt}&EndAt=${EndAt}`);

export const getUserFunnelMetrics = (StartAt = '', EndAt = '', CreatingPartner = '') =>
  apiClient.get(`overview/user-funnel?StartAt=${StartAt}&EndAt=${EndAt}${CreatingPartner ? `&CreatingPartner=${CreatingPartner}` : ''}`);

export const getUserFunnelBreakdown = (StartAt = '', EndAt = '', stage = 0, page = 1, pageSize = 20, CreatingPartner = '') =>
  apiClient.get(`overview/user-funnel/breakdown?StartAt=${StartAt}&EndAt=${EndAt}&stage=${stage}&page=${page}&pageSize=${pageSize}${CreatingPartner ? `&CreatingPartner=${CreatingPartner}` : ''}`);

export const getUserActivityChannelSummary = (StartAt = '', EndAt = '', CreatingPartner = '') =>
  apiClient.get(`overview/user-activity-channel-summary?StartAt=${StartAt}&EndAt=${EndAt}${CreatingPartner ? `&CreatingPartner=${CreatingPartner}` : ''}`);

export const getUnverifiedUsersActiveLoans = (StartAt = '', EndAt = '', CreatingPartner = '') => {
  let url = `overview/unverified-users-active-loans?StartAt=${StartAt}&EndAt=${EndAt}`;
  if (CreatingPartner) {
    url += `&CreatingPartner=${CreatingPartner}`;
  }
  return apiClient.get(url);
};

export const getUnverifiedBusinessesActiveLoans = (StartAt = '', EndAt = '', CreatingPartner = '') => {
  let url = `overview/unverified-businesses-active-loans?StartAt=${StartAt}&EndAt=${EndAt}`;
  if (CreatingPartner) {
    url += `&CreatingPartner=${CreatingPartner}`;
  }
  return apiClient.get(url);
};
